import { signInWithRedirect, getCurrentUser, fetchAuthSession, signOut } from "aws-amplify/auth";
import { getSsoProviderName } from "../../config";

/**
 * Sign in with Cognito hosted UI (default provider)
 */
export const signIn = () => {
  return signInWithRedirect();
};

/**
 * Sign in with Entra ID (Azure AD) SSO
 * This redirects the user to the Entra ID login page via Cognito
 */
export const signInWithSSO = () => {
  const providerName = getSsoProviderName();
  console.log(`Initiating SSO login with provider: ${providerName}`);
  
  // Use signInWithRedirect with custom provider
  // The provider name must match exactly what's configured in Cognito
  return signInWithRedirect({ 
    provider: { 
      custom: providerName 
    } 
  });
};

export const logOut = () => {
  return signOut().then(() => {
    return null;
  });
};

export const getUser = async () => {
  try {
    const user = await getCurrentUser();
    const session = await fetchAuthSession();

    if (session.tokens) {
      const payload = session.tokens.idToken.payload;
      return {
        ...user,
        given_name: payload.given_name,
        family_name: payload.family_name,
      };
    }

    return user;
  } catch (error) {
    console.error("Error fetching user:", error);
    return null;
  }
};

export const getSession = () => {
  return fetchAuthSession();
};
